"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var PhoneInput_1 = __importDefault(require("../inputs/PhoneInput"));
var InputField = function (_a) {
    var name = _a.name, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1];
    return react_1.default.createElement(PhoneInput_1.default, __assign({}, field, { name: name, hasError: !!meta.error, size: size, readOnly: readOnly, toolTip: toolTip }));
};
InputField.defaultProps = {
    size: undefined,
    readOnly: false,
    toolTip: undefined,
};
exports.default = InputField;
